var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gallery-controller"},[_vm._t("default",null,{"items":_vm.limitedItems,"toggle":_vm.toggle,"limited":_vm.items.length > _vm.limit,"opened":_vm.opened})],2)}
var staticRenderFns = []

export { render, staticRenderFns }